/**
 * A full-width quick quote band placed right under the hero of pages that
 * visitors reach from search but that had no quote link near the top:
 * doctor profiles, the results hub, reviews, the locations index and the
 * state and city hubs.
 *
 * Baseline, 9 Oct 2026: on these pages the first quote link in the body was
 * between 2,700 and 16,400 px down (doctor pages: only at the very end), or
 * absent (city hubs). On desktop the sticky header offers a consultation,
 * not a quote.
 *
 * Same line and button label as InlineQuoteCta, which is the approved
 * wording: no price claim. Wording changes need Brian's approval.
 *
 * The link is relative, so the site's link decorator adds the stored UTM and
 * click ID parameters, and the Zaraz trigger on a[href*="quick-quote"] sends
 * click_to_qq1. data-cta-location tells the bands apart from other links.
 */
export function QuoteBand() {
  return (
    <aside
      data-cta-location="band"
      aria-label="Get a quick quote"
      className="border-y border-border bg-muted"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-start gap-4 px-4 py-5 sm:flex-row sm:items-center sm:justify-between md:py-6">
        <p className="text-base font-semibold leading-snug text-foreground md:text-lg">
          See what your hair transplant would cost
        </p>
        <a
          href="/quick-quote-part-1/"
          className="inline-block w-full bg-primary px-6 py-3 text-center text-sm font-bold tracking-wider text-primary-foreground no-underline transition hover:bg-primary/90 sm:w-auto"
        >
          Get a Quick Quote
        </a>
      </div>
    </aside>
  );
}
